var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("br"),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-button",
            {
              staticClass: "mb-3",
              attrs: { size: "sm" },
              on: {
                click: function($event) {
                  _vm.download()
                }
              }
            },
            [_vm._v("Download for Excel")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("table", { staticClass: "table table-striped" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "tbody",
          _vm._l(_vm.rows, function(item) {
            return _c("tr", { key: item.dimension, staticClass: "c" }, [
              _c("td", { staticClass: "text-left align-top" }, [
                _vm._v("\n        " + _vm._s(item.dimension) + "\n        ")
              ]),
              _vm._v(" "),
              _c("td", { staticClass: "text-right align-top" }, [
                _vm._v("\n        " + _vm._s(item.responses) + "\n        ")
              ]),
              _vm._v(" "),
              _c("td", { staticClass: "text-right align-top" }, [
                _vm._v(
                  "\n        " +
                    _vm._s((item.score || 0).toFixed(2)) +
                    "\n        "
                )
              ]),
              _vm._v(" "),
              _c(
                "td",
                { staticClass: "text-left align-top" },
                [
                  item.dimension !== "Total"
                    ? _c(
                        "b-btn",
                        {
                          class: _vm.elementShowState[item.dimension]
                            ? null
                            : "collapsed",
                          attrs: {
                            "aria-controls": item.dimension.replace(
                              "/[^a-zA-Z0-9]/g"
                            ),
                            "aria-expanded": _vm.elementShowState[
                              item.dimension
                            ]
                              ? "true"
                              : "false"
                          },
                          on: {
                            click: function($event) {
                              _vm.elementShowState[item.dimension] = !_vm
                                .elementShowState[item.dimension]
                            }
                          }
                        },
                        [_vm._v("Show/Hide")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-collapse",
                    {
                      staticClass: "mt-2",
                      attrs: { id: item.dimension.replace("/[^a-zA-Z0-9]/g") },
                      model: {
                        value: _vm.elementShowState[item.dimension],
                        callback: function($$v) {
                          _vm.$set(_vm.elementShowState, item.dimension, $$v)
                        },
                        expression: "elementShowState[item.dimension]"
                      }
                    },
                    [
                      _c("b-card", [
                        _c("table", { staticClass: "table table-striped" }, [
                          _c("thead", [
                            _c("tr", [
                              _c("th", [_vm._v("Element")]),
                              _vm._v(" "),
                              _c("th", [_vm._v("Responses")]),
                              _vm._v(" "),
                              _c("th", [_vm._v("Average")])
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "tbody",
                            _vm._l(item.elements, function(element) {
                              return _c(
                                "tr",
                                { key: element.name, staticClass: "c" },
                                [
                                  _c("td", [_vm._v(_vm._s(element.name))]),
                                  _vm._v(" "),
                                  _c("td", [_vm._v(_vm._s(element.responses))]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(_vm._s(element.average.toFixed(2)))
                                  ])
                                ]
                              )
                            })
                          )
                        ])
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ])
          })
        )
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Group")]),
        _vm._v(" "),
        _c("th", [_vm._v("Total Responses")]),
        _vm._v(" "),
        _c("th", [_vm._v("Score")]),
        _vm._v(" "),
        _c("th", [_vm._v("Elements")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-920c1a38", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-920c1a38","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ScoreSummary.vue
// module id = null
// module chunks = 